import Loading from 'components/Loading';
import React from 'react';

const lazyWithSuspense = (importFn: () => Promise<{ default: React.ComponentType<any> }>) => {
  const LazyComponent = React.lazy(importFn);
  return (props: any) => React.createElement(
    React.Suspense,
    { fallback: React.createElement(Loading) },
    React.createElement(LazyComponent, props),
  );
};

export default lazyWithSuspense;
